<template>
  <div class="ts-space-y-2">
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs required" >{{ $t('currency.code') }}</label>
        <input
          v-model="model.currency_code"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('currency_code') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('currency_code')"
        >{{ errors.first('currency_code') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs required" >{{ $t('currency.description') }}</label>
        <input
          v-model="model.currency_description"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('currency_description') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('currency_description')"
        >{{ errors.first('currency_description') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{ $t('currency.symbol') }}</label>
        <input
          v-model="model.currency_symbol"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('currency_symbol') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('currency_symbol')"
        >{{ errors.first('currency_symbol') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{ $t('currency.rounding') }}</label>
        <input
          v-model.number="model.currency_rounding"
          type="number"
          class="form-control"
          :class="{ 'is-invalid': errors.has('currency_rounding') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('currency_rounding')"
        >{{ errors.first('currency_rounding') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <ts-checkbox v-model="model.is_default">{{ $t('currency.default') }}</ts-checkbox>
                        <div
          class="validate ts-text-xs"
          v-if="errors.has('is_default')"
        >{{ errors.first('is_default') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ts-mt-3 text-right">
        <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
          {{
          $t('cancel')
          }}
        </ts-button>
        <ts-button
          v-if="!isUpdate"
          color="primary"
          @click.prevent="onSave"
          :waiting="waiting"
        >{{ $t('save') }}</ts-button>
        <ts-button
          v-if="isUpdate"
          color="primary"
          @click.prevent="onUpdate"
          :waiting="waiting"
        >{{ $t('update') }}</ts-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'companyForm',
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      waiting_new: false,
      model: {
				currency_id: null,
				currency_code: null,
				currency_description: null,
				currency_symbol: null,
				currency_rounding: 2,
				is_default: false
      }
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('exchangeRate/currency', ['edit_data']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('exchangeRate/currency/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('exchangeRate/currency/update', {
          id: this.model.currency_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.currency_id = this.edit_data.currency_id
        this.model.currency_code = this.edit_data.currency_code
        this.model.currency_description =  this.edit_data.currency_description
        this.model.currency_symbol =  this.edit_data.currency_symbol
        this.model.currency_rounding =  this.edit_data.currency_rounding
        this.model.is_default =  this.edit_data.is_default
      }
    }
  }
}
</script>
